<template>
    <Teleport to="body">
        <transition name="connectivity-slide">
            <div
                v-if="status !== 'ONLINE'"
                class="connectivity-banner"
                :class="status === 'OFFLINE' ? 'is-offline' : 'is-outage'"
                role="alert"
                aria-live="polite"
            >
                <span class="connectivity-icon">
                    <PhWifiSlash
                        v-if="status === 'OFFLINE'"
                        :size="18"
                        weight="bold"
                    />
                    <PhCloudWarning v-else :size="18" weight="bold" />
                </span>
                <div class="connectivity-text">
                    <span class="connectivity-title">
                        {{
                            status === "OFFLINE"
                                ? $t("connectivity.offline.title")
                                : $t("connectivity.outage.title")
                        }}
                    </span>
                    <span class="connectivity-subtitle">
                        {{
                            status === "OFFLINE"
                                ? $t("connectivity.offline.message")
                                : $t("connectivity.outage.message")
                        }}
                    </span>
                </div>
            </div>
        </transition>
    </Teleport>
</template>

<script lang="ts" setup>
    import { PhWifiSlash, PhCloudWarning } from "@phosphor-icons/vue";
    import { useConnectivity } from "@/composables/useConnectivity";

    const { connectivityStatus: status } = useConnectivity();
</script>

<style lang="scss" scoped>
    .connectivity-banner {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 99999;
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 14px;
        padding-top: max(10px, env(safe-area-inset-top));
        color: var(--color-always-white, #fff);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);

        &.is-offline {
            background: var(--color-grey-700, #444);
        }

        &.is-outage {
            background: var(--ion-color-warning, #c47d00);
        }
    }

    .connectivity-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        line-height: 0;
    }

    .connectivity-text {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-width: 0;
        line-height: 1.25;
    }

    .connectivity-title {
        font-size: 14px;
        font-weight: 700;
    }

    .connectivity-subtitle {
        font-size: 12px;
        font-weight: 500;
        opacity: 0.9;
    }

    .connectivity-slide-enter-active,
    .connectivity-slide-leave-active {
        transition:
            transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),
            opacity 0.3s ease;
    }

    .connectivity-slide-enter-from,
    .connectivity-slide-leave-to {
        transform: translateY(-100%);
        opacity: 0;
    }
</style>
